import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=1bfa9414&scoped=true&"
import script from "./Sync.vue?vue&type=script&lang=js&"
export * from "./Sync.vue?vue&type=script&lang=js&"
import style0 from "./Sync.vue?vue&type=style&index=0&id=1bfa9414&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa9414",
  null
  
)

export default component.exports